(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.DeleteDialogController = (function(superClass) {
    extend(DeleteDialogController, superClass);

    function DeleteDialogController(scope, transitions, modalInstance) {
      var base, base1, base2, base3, base4;
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.save = bind(this.save, this);
      DeleteDialogController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      if ((base = this.scope).title == null) {
        base.title = 'Delete';
      }
      if ((base1 = this.scope).item_name == null) {
        base1.item_name = 'item';
      }
      if ((base2 = this.scope).plural == null) {
        base2.plural = false;
      }
      this.scope.fullpage = false;
      if ((base3 = this.scope).replace_body == null) {
        base3.replace_body = null;
      }
      if ((base4 = this.scope)["delete"] == null) {
        base4["delete"] = (function(_this) {
          return function() {
            return void 0;
          };
        })(this);
      }
    }

    DeleteDialogController.prototype.save = function() {
      var promise;
      this.setAlert({
        type: 'info',
        msg: 'Deleting...'
      });
      promise = this.scope["delete"]();
      if (promise && (promise.then != null)) {
        return promise.then((function(_this) {
          return function(response) {
            var jsr;
            jsr = response.data;
            if ((jsr == null) || jsr === '') {
              return _this.closeWithAlert({
                type: 'success',
                msg: 'Deleted successfully'
              }, {});
            } else {
              return _this.closeWithAlert(jsr.status, jsr.data, false);
            }
          };
        })(this));
      }
    };

    return DeleteDialogController;

  })(DialogController);

}).call(this);
